
import digitoonLogo from "../../../../shared-assets/icons/icon-72x72.png";

import Image from "next/image";
import { useContext, useEffect, useState } from "react";
// @ts-ignore
import AppNotifCtx from "../../../services/notif-context-services";
import styles from "./app-notification.module.scss";


function AppNotification() {
  const notifCtx = useContext(AppNotifCtx);
  const { show, notif, clearNotif } = notifCtx;
  const [typeClass, setTypeClass] = useState("");
  const [transShow, setTransShow] = useState<"init" | "on" | "off">("init");
  const [stateClass, setstateClass] = useState("");

  useEffect(() => {
    let notifTimeout = 3;
    if (show) {
      setTransShow("on");
      switch (notif.notifType) {
        case "success":
          // console.log("case success");
          setTypeClass(styles.success);
          break;
        case "error":
          // console.log("case error");
          setTypeClass(styles.error);
          break;
        case "warning":
          // console.log("case warning");
          setTypeClass(styles.warning);
          break;
        case "pending":
          // console.log("case pending");
          notifTimeout = 10;
          break;
        default:
          break;
      }

      const timer = setTimeout(() => setTransShow("off"), notifTimeout * 1000);
      return () => {
        clearTimeout(timer);
      };
    } else {
      setTransShow("off");
    }
  }, [notifCtx]);

  useEffect(() => {
    if (transShow === "off") {
      setstateClass(styles.hide)
      const timeout = setTimeout(() => clearNotif(), 1000);
      return () => clearTimeout(timeout);
    } else if (transShow === "on") {
      setstateClass(styles.show)
    }

  }, [transShow]);

  const result = (show || transShow === "on") ? (
    <div
      className={`${styles.wrapper} ${stateClass} ${typeClass}`}
      onClick={() => clearNotif()}
    >
      <div className={styles.inner}>
        <div className={styles.logo}>
          <Image src={digitoonLogo} alt="logo"/>
        </div>
        <div className={styles.message}>{notif.message || (notif as any).detail || "خطای نا مشخص"}</div>
      </div>
    </div>
  ) : null;

  return result;
}

export default AppNotification;
